var _defs, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCgl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_518",
    "data-name": "Group 518",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 214.084,
    height: 42.22,
    viewBox: "0 0 214.084 42.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2119",
    "data-name": "Rectangle 2119",
    width: 214.084,
    height: 42.22,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M194.775,20.64h7.57c1.954,0,2.52-.573,2.52-2.563V12.308c0-1.987-.565-2.562-2.52-2.562h-7.57c-1.971,0-2.542.576-2.542,2.562v5.769c0,1.99.571,2.563,2.542,2.563m-.769-9.458h9.106v7.981h-9.106Z",
    transform: "translate(-116.394 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M244.835,9.747h-8.8V20.641h1.775V16.377h7.023c1.625,0,2.287-.607,2.287-2.1V11.843c0-1.488-.662-2.1-2.287-2.1m.492,4.069c0,.983-.426,1.169-1.212,1.169h-6.3V11.119h6.3c.786,0,1.212.186,1.212,1.171Z",
    transform: "translate(-142.916 -5.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M283.753,19.184h-8.8V15.657h5.322V14.264h-5.322v-3.1h8.715V9.746H273.178V20.64h10.575Z",
    transform: "translate(-165.404 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M310.33,14.217a17.886,17.886,0,0,0-.127-2.392l-.017-.122.062.105a4.2,4.2,0,0,0,.926,1.067c.06.054.118.106.173.159l8.412,7.607h.984V9.746h-1.627v5.977a15.67,15.67,0,0,0,.169,2.69l.016.1-.059-.077a10.4,10.4,0,0,0-1.249-1.376l-8.179-7.31H308.7V20.64h1.625Z",
    transform: "translate(-186.915 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M361.779,14.22H353.1V9.746h-1.772V20.64H353.1V15.678h8.683V20.64h1.775V9.746h-1.775Z",
    transform: "translate(-212.721 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M401.018,20.64h1.96l-6.06-10.894H395L389.043,20.64h1.747l1.4-2.694h7.432ZM392.925,16.6l.021-.036,2.97-5.642.021.043L398.9,16.6Z",
    transform: "translate(-235.559 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M483.15,19.184h-8.8V15.657h5.322V14.264h-5.322v-3.1h8.716V9.746H472.573V20.64H483.15Z",
    transform: "translate(-286.135 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M509.729,14.217a17.9,17.9,0,0,0-.128-2.392l-.015-.122.061.105a4.237,4.237,0,0,0,.922,1.065q.093.082.177.161l8.413,7.607h.983V9.746h-1.626v5.977a15.559,15.559,0,0,0,.17,2.69l.015.1-.058-.077a10.657,10.657,0,0,0-1.249-1.376l-8.18-7.31H508.1V20.64h1.625Z",
    transform: "translate(-307.648 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M215.091,58.578,206.4,73.945h3.482l1.8-3.386h9.86l.015.026,1.844,3.361h3.932l-8.817-15.367Zm-1.94,9.293.04-.074,3.493-6.376.042.081,3.365,6.369Z",
    transform: "translate(-124.97 -35.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M447.6,58.578l-8.7,15.367h3.481l1.8-3.386h9.858l.015.026,1.844,3.361h3.932l-8.817-15.367Zm-1.943,9.293.041-.074,3.492-6.376.044.081,3.366,6.369Z",
    transform: "translate(-265.746 -35.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M276.377,67.963l-.04-.05-7.267-9.334h-2.835V73.945h2.808V64.434c0-.486-.026-.977-.089-1.644l-.032-.344.128.322a6.761,6.761,0,0,0,.922,1.576l5.8,7.744h.669l5.8-7.715a9.975,9.975,0,0,0,.9-1.61l.127-.266-.033.294a16.261,16.261,0,0,0-.121,1.642v9.511h3.23V58.579h-2.8Z",
    transform: "translate(-161.201 -35.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M334.071,67.2h7.135V64.664h-7.135V61.118H346.3V58.579H330.574V73.945H346.45v-2.81h-12.38Z",
    transform: "translate(-200.157 -35.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M401.065,58.579h-3.5V73.945h15.1v-2.81h-11.6Z",
    transform: "translate(-240.72 -35.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M512.977,66.071l-.385-.052.385-.047c1.717-.21,2.625-1.095,2.625-2.558V61.527c0-2.066-1.025-2.949-3.426-2.949h-13.2V73.945h12.24c3.031,0,4.505-.973,4.505-2.977V68.99a2.794,2.794,0,0,0-2.744-2.919M502.414,61h8.262c1.074,0,1.7.19,1.7,1.159v1.468c0,.969-.623,1.159-1.7,1.159h-8.262Zm10.049,8.832c0,1.208-.6,1.427-1.787,1.427h-8.262V67.232h8.262c1.51,0,1.787.482,1.787,1.427Z",
    transform: "translate(-302.122 -35.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M156.883,20.64h8.483c.135,0,.256-.007.373-.014l.045,0V19.162h-9.669v-7.98h9.669V9.766h-.009c-.149-.009-.3-.02-.471-.02h-8.422c-1.971,0-2.542.575-2.542,2.562v5.769c0,1.99.571,2.563,2.542,2.563",
    transform: "translate(-93.451 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M442.872,18.077V14.561h-6.205v1.35H441.1v3.252H432.48V11.182h10.392V9.762l-.068,0c-.1-.007-.213-.013-.331-.013h-9.225c-1.971,0-2.541.576-2.541,2.563v5.769c0,1.99.57,2.563,2.541,2.563h7.084c1.972,0,2.541-.573,2.541-2.563",
    transform: "translate(-260.785 -5.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M157.831,58.579c-2.938,0-3.787.81-3.787,3.607v8.153c0,2.8.849,3.606,3.787,3.606H168.5c2.938,0,3.787-.809,3.787-3.606V65.053h-9.281v2.54h5.872v3.543H157.542v-9.9h14.782V58.579H157.831Z",
    transform: "translate(-93.271 -35.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M38.272,39.351v11.3h19.5v-3.6H41.835v-7.7Z",
    transform: "translate(-23.173 -23.826)",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M53.915,19.836h-34.6v26.7h34.6v-19H34.542v3.6h15.8v11.8H22.876V23.437H53.915Z",
    transform: "translate(-11.695 -12.011)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M0,.322V42.386H42.22V38.814H3.561V3.923H42.22V.322Z",
    transform: "translate(0 -0.195)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCgl);
export default __webpack_public_path__ + "static/media/logo-cgl.f394fb341b0d47c683e0f86a6ed7a730.svg";
export { ForwardRef as ReactComponent };